import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";

// ======================================================
// HR WHITELIST (MATCHES ProtectedHrRoute.jsx)
// ======================================================
// ======================================================
// SIDEBAR (DARK GREY + LOGO BOX + WHITE ICONS)
// ======================================================

export default function Sidebar({
  isOpen,
  setIsOpen,
  isMobile,
  isManagerView,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user"));

  const isManager = user?.is_manager;

  const isHr = user?.is_hr;
  const isSuperAdmin = user?.is_super_admin;

  const [openMenu, setOpenMenu] = useState({
    leave: true,
    hr: true,
  });

  const toggleMenu = (menu) => {
    setOpenMenu((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const isActive = (path) => location.pathname === path;

  const isParentActive = (paths) => paths.includes(location.pathname);
  const handleNavigate = (path) => {
  if (location.pathname === path) {
    if (isMobile) setIsOpen(false);
    return;
  }

  navigate(path);

  if (isMobile) {
    setIsOpen(false);
  }
};

  return (
    <div
      style={{
        ...styles.sidebar,
        left: isMobile ? (isOpen ? "0" : "-250px") : "0",
        transition: "0.3s",
        zIndex: 1000,
      }}
    >
      {/* NEW LOGO SECTION */}
      <Box sx={styles.logoBox}>
        <img
          src="https://images.railyatri.in/ry_images_prod/logo-1601537442.png"
          alt="Logo"
          style={{ width: 140, marginBottom: 6 }}
        />

        <Typography sx={styles.logoSubText}>Leave Management App</Typography>
      </Box>

      {/* MENU */}
      <div style={styles.menuContainer}>
        <MenuItem
          icon={<HomeOutlinedIcon style={styles.icon} />}
          label="Home"
          active={isActive("/home")}
          onClick={() => handleNavigate("/home")}
        />

        {/* LEAVE */}
        {/* LEAVE MENU ONLY FOR NORMAL USERS */}

        <div>
          <MenuItem
            icon={<EventNoteOutlinedIcon style={styles.icon} />}
            label="Leave"
            active={isParentActive([
              "/leave/apply",
              "/leave/balance",
              "/leave/calendar",
              
            ])}
            onClick={() => toggleMenu("leave")}
            arrow={openMenu.leave}
          />

          <div
            style={{
              ...styles.subMenu,
              maxHeight: openMenu.leave ? "500px" : "0px",
            }}
          >
            <SubItem
              label="Apply Leave"
              active={isActive("/leave/apply")}
              onClick={() => handleNavigate("/leave/apply")}/>

            <SubItem
              label="Leave Balance"
              active={isActive("/leave/balance")}
              onClick={() => handleNavigate("/leave/balance")}/>

            <SubItem
              label="Leave Calendar"
              active={isActive("/leave/calendar")}
              onClick={() => handleNavigate("/leave/calendar")}/>
          </div>
          {/* REVIEW LEAVE ONLY FOR MANAGER */}
          {isManager && (
            <MenuItem
              icon={<EventNoteOutlinedIcon style={styles.icon} />}
              label="Review Leave"
              active={isActive("/manager/review")}
              onClick={() => handleNavigate("/manager/review")}
            />
          )}

          {/* {isManager && (
            <MenuItem
              icon={<EventNoteOutlinedIcon style={styles.icon} />}
              label="Review Leave M"
              active={isActive("/manager/review_new")}
              onClick={() => navigate("/manager/review_new")}
            />
          )} */}

          
{/* ====================================================== */}
{/* MANAGER DASHBOARD */}
{/* ====================================================== */}

{isManager && (
  <MenuItem icon={<EventNoteOutlinedIcon style={styles.icon} />}
    label="Leave Dashboard"
    active={isParentActive([
      "/manager/dashboard",
      "/manager/monthly-summary",
      "/manager/transactions",
    ])}
    onClick={() => handleNavigate("/manager/dashboard")}
  />
)}

{(isHr || isSuperAdmin) && (
  <div>
    <MenuItem
      icon={<EventNoteOutlinedIcon style={styles.icon} />}
      label="HR Admin"
      active={isParentActive([
        "/hr/balances",
        "/hr/transactions",
        "/hr/activity-logs",
        "/hr/users",
      ])}
      onClick={() => toggleMenu("hr")}
      arrow={openMenu.hr}
    />

    <div
      style={{
        ...styles.subMenu,
        maxHeight: openMenu.hr ? "600px" : "0px",
      }}
    >
      <SubItem
        label="Leave Balances"
        active={isActive("/hr/balances")}
        onClick={() => handleNavigate("/hr/balances")}
      />

      <SubItem
        label="Leave Transactions"
        active={isActive("/hr/transactions")}
        onClick={() => handleNavigate("/hr/transactions")}
      />

      <SubItem
        label="Activity Logs"
        active={isActive("/hr/activity-logs")}
        onClick={() => handleNavigate("/hr/activity-logs")}
      />

      {isSuperAdmin && (
        <SubItem
          label="HR Users"
          active={isActive("/hr/users")}
          onClick={() => handleNavigate("/hr/users")}
        />
      )}
    </div>
  </div>
)}
        </div>
      </div>

      {/* FOOTER */}
      <div style={styles.footer}>
        <div style={styles.footerItem}></div>
      </div>
    </div>
  );
}

// ======================================================
// COMPONENTS
// ======================================================

function MenuItem({ icon, label, active, onClick, arrow }) {
  return (
    <div
      onClick={onClick}
      style={{
        ...styles.menuItem,
        ...(active ? styles.activeItem : {}),
      }}
    >
      {icon}
      <span style={styles.text}>{label}</span>
      {arrow !== undefined && (
        <span style={styles.arrow}>{arrow ? "▲" : "▼"}</span>
      )}
    </div>
  );
}

function SubItem({ label, active, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        ...styles.subItem,
        ...(active ? styles.activeSubItem : {}),
      }}
    >
      {label}
    </div>
  );
}

// ======================================================
// STYLES
// ======================================================

const styles = {
  sidebar: {
    width: "250px",
    height: "100vh",
    background: "#1f4494",
    position: "fixed",
    top: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    color: "#e4e7eb",
  },

  logoBox: {
    px: 3,
    py: 3,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    borderBottom: "1px solid #3a3f45",
  },

  logoSubText: {
    color: "#94a3b8",
    fontSize: "13px",
  },

  menuContainer: {
    flex: 1,
    paddingTop: "10px",
  },

  menuItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px 20px",
    cursor: "pointer",
    borderLeft: "3px solid transparent",
  },

  activeItem: {
    background: "#32383f",
    borderLeft: "3px solid #3b82f6",
  },

  icon: {
    marginRight: "12px",
    fontSize: "20px",
    color: "#ffffff",
  },

  text: {
    flex: 1,
    fontSize: "15px",
  },

  arrow: {
    fontSize: "12px",
    color: "#9aa5b1",
  },

  subMenu: {
    overflow: "hidden",
    transition: "0.3s",
  },

  subItem: {
    padding: "10px 50px",
    fontSize: "14px",
    cursor: "pointer",
    color: "#cbd2d9",
  },

  activeSubItem: {
    background: "#3a3f45",
    color: "#fff",
  },

  footer: {
    borderTop: "1px solid #3a3f45",
    padding: "10px 0",
  },

  footerItem: {
    padding: "10px 20px",
    fontSize: "13px",
    cursor: "pointer",
    color: "#cbd2d9",
  },
};